import React from 'react';
import Svg from 'rp-react-svg-icon';

const NoDataComponent = () => (
    <div className="ui-errorMessage">
            <div className="ui-errorMessage__text"><b>0</b>  Stallions found</div>
            <div className="ui-errorMessage__text">
                No stallions match your search criteria. Please amend your filters and try again.
            </div>
    </div>
);


export default NoDataComponent;



// WEBPACK FOOTER //
// ./src/client/components/GriddleRP/NoDataComponent.js